import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiCalendar, FiUser } from 'react-icons/fi';
import api from '../utils/api';

const categories = ['All','Food Safety','ISO Certification','Regulatory Compliance','Auditing','Training','Pest Control','Quality Assurance','Other'];

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [activeCategory, setActiveCategory] = useState('All');
  const [loading, setLoading] = useState(true);
  const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    api.get('/projects').then(r => { setProjects(r.data); setFiltered(r.data); }).catch(() => {}).finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setFiltered(activeCategory === 'All' ? projects : projects.filter(p => p.category === activeCategory));
  }, [activeCategory, projects]);

  return (
    <div style={{ paddingTop: 74 }}>
      <section style={{ background: 'linear-gradient(135deg, #060F1E 0%, var(--navy) 100%)', padding: '5.5rem 0 4rem' }}>
        <div className="container">
          <span className="label" style={{ marginBottom: '1rem', display: 'inline-flex' }}>Our Portfolio</span>
          <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: 'clamp(2.2rem,4vw,3.2rem)', color: 'white', marginBottom: '1.25rem', maxWidth: 560, lineHeight: 1.15 }}>Projects & Case Studies</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.05rem', maxWidth: 520, lineHeight: 1.75 }}>Real results delivered for food businesses across Ghana and West Africa.</p>
        </div>
      </section>

      <section className="section-pad" style={{ background: 'var(--off-white)' }}>
        <div className="container">
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '3rem', justifyContent: 'center' }}>
            {categories.map(c => (
              <button key={c} onClick={() => setActiveCategory(c)}
                style={{ padding: '0.5rem 1.2rem', borderRadius: '50px', border: '1.5px solid', borderColor: activeCategory === c ? 'var(--gold)' : 'var(--gray-200)', background: activeCategory === c ? 'var(--gold)' : 'white', color: activeCategory === c ? 'var(--navy)' : 'var(--gray-500)', fontWeight: activeCategory === c ? 700 : 400, fontSize: '0.82rem', cursor: 'pointer', transition: 'all 0.2s', fontFamily: 'Outfit, sans-serif' }}>
                {c}
              </button>
            ))}
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '5rem', color: 'var(--gray-400)' }}>Loading projects...</div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '6rem 2rem' }}>
              <div style={{ fontSize: '4rem', marginBottom: '1.25rem' }}>📁</div>
              <h3 style={{ fontFamily: 'Fraunces, serif', color: 'var(--navy)', marginBottom: '0.5rem' }}>No Projects Yet</h3>
              <p style={{ color: 'var(--gray-400)' }}>Projects will appear here once added by the administrator.</p>
            </div>
          ) : (
            <div className="grid-3">
              {filtered.map((p, i) => (
                <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.07 }}>
                  <Link to={`/projects/${p.id}`} style={{ display: 'flex', flexDirection: 'column', background: 'white', borderRadius: '20px', overflow: 'hidden', boxShadow: 'var(--shadow-sm)', border: '1px solid var(--gray-100)', transition: 'all 0.3s', textDecoration: 'none', height: '100%' }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = 'var(--shadow-lg)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; }}>
                    <div style={{ position: 'relative', height: 220, overflow: 'hidden', background: 'var(--navy)' }}>
                      {p.images?.[0] ? <img src={`${BACKEND}${p.images[0]}`} alt={p.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '3.5rem' }}>🏭</div>}
                      {p.category && <span style={{ position: 'absolute', top: '1rem', left: '1rem', background: 'var(--gold)', color: 'var(--navy)', padding: '0.25rem 0.85rem', borderRadius: '50px', fontSize: '0.7rem', fontWeight: 700 }}>{p.category}</span>}
                    </div>
                    <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <h3 style={{ fontFamily: 'Fraunces, serif', fontSize: '1.05rem', color: 'var(--navy)', marginBottom: '0.6rem', lineHeight: 1.3 }}>{p.title}</h3>
                      <p style={{ color: 'var(--gray-500)', fontSize: '0.83rem', lineHeight: 1.65, flex: 1, marginBottom: '1.25rem', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{p.description}</p>
                      <div style={{ display: 'flex', gap: '1rem', fontSize: '0.78rem', color: 'var(--gray-400)', marginBottom: '1rem' }}>
                        {p.client && <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}><FiUser />{p.client}</span>}
                        {p.completion_date && <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}><FiCalendar />{new Date(p.completion_date).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' })}</span>}
                      </div>
                      <span style={{ color: 'var(--gold)', fontWeight: 600, fontSize: '0.83rem', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>View Case Study <FiArrowRight style={{ fontSize: '0.78rem' }} /></span>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
